var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading",style:(_vm.loadingBackgroundColor)},[_c('div',{staticClass:"sp-circle"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }